class wcKits extends HTMLElement {
  constructor() {
    super()
    console.log('Kit builder', this);
    this.wcKitsWrapper = this.closest('wc-kits-wrapper');
    this.bundledProducts = []
    this.bundledProductIds = []
    this.bundledProductsTitles = []
    this.bundleParentId = this.dataset.bundle;
    this.bundleTag = this.dataset.tag;
    this.bundleItemHtml = ''
    this.bundlePercentage = 0;
    this.bundleDiscount = 0;
    this.bundleTotalCost = 0;
    this.bundleDiscountCost = 0;
    this.bundleItemsTotal = 0;
    this.bundleItemPos = 0;
    this.bundleAvailable = true;
    this.bundleAvailableGlobal = this.dataset.bundleavailable;
    this.currentStep = 1;
    this.errorData = '<h5 class="h4">There was a problem loading products.</h5><p>Please refresh the page and try again.</p>';
    this.fetchAlways = true; // setting this true prevents using sessionStorage data and fetches new product data everytime

    this.bundleForm = document.getElementById('bundle-form');
    this.bundleFormBuy = this.bundleForm.querySelector('.product-form__submit'); 
    this.priceWrapEl = document.querySelector('.wc-info-container__top .product__price__wrapper'); 

    this.sessionStorageProdKey = `wc-bundle-prod-${this.bundleParentId}`;
    this.sessionStorageProdData = sessionStorage.getItem(this.sessionStorageProdKey);
    this.sessionStorageBundlecostKey = `wc-bundle-bundlecost-${this.bundleParentId}`;
    this.sessionStorageBundleCostData = sessionStorage.getItem(this.sessionStorageBundlecostKey);
    this.sessionStorageBundleDiscountCostKey = `wc-bundle-bundlediscountcost-${this.bundleParentId}`;
    this.sessionStorageBundleDiscountCostData = sessionStorage.getItem(this.sessionStorageBundleDiscountCostKey);

    this.sessionStorageBundleSavingCostKey = `wc-bundle-bundlesavingcost-${this.bundleParentId}`;
    this.sessionStorageBundleSavingCostData = sessionStorage.getItem(this.sessionStorageBundleSavingCostKey);

    if (this.priceWrapEl){
      this.priceEl = this.priceWrapEl.querySelector('.price');
      this.priceRegularWrapEl = this.priceEl.querySelectorAll('.price__regular');
      this.priceSaleWrapEl = this.priceEl.querySelectorAll('.price__sale');
      this.priceRegularEl = this.priceEl.querySelectorAll('.price-item--regular');
      this.priceSaleEl = this.priceEl.querySelectorAll('.price-item--sale');
      this.priceCostSaving = this.priceWrapEl.querySelectorAll('.bundle__cost-saving');
    }

    if (this.bundleTag.includes('|')){
      let bundleTagParts = this.bundleTag.split('|');
      this.bundlePercentage = bundleTagParts[1].split(':')[1];
      this.bundleItemsTotal = parseInt(bundleTagParts[2].split(':')[1]);
      this.fetchBundleProducts();
    }else{
      return
    }
    
  }

  async fetchBundleProducts() {

    this.bundleForm.querySelector('.form-loading').classList.remove('hidden');

    if (this.sessionStorageProdData && this.fetchAlways != true) {
      this.innerHTML = JSON.parse(this.sessionStorageProdData);
      this.priceRegularEl.forEach(priceReg => { priceReg.innerHTML = JSON.parse(this.sessionStorageBundleCostData) });
      this.priceSaleEl.forEach(priceSale => { priceSale.innerHTML = JSON.parse(this.sessionStorageBundleDiscountCostData) });
      this.priceCostSaving.forEach(priceCost => { priceCost.querySelector('span').innerHTML = JSON.parse(this.sessionStorageBundleSavingCostData) });

      if(JSON.parse(this.sessionStorageBundleCostData) != JSON.parse(this.sessionStorageBundleDiscountCostData)){
        this.priceRegularWrapEl.forEach(priceReg => { priceReg.classList.add('hidden')});
        this.priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'block'});
      }else{
        this.priceRegularWrapEl.forEach(priceReg => { priceReg.classList.remove('hidden')});
        this.priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'none'});
        this.priceCostSaving.forEach(priceCost => { priceCost.classList.add('visually-hidden') });
      }

      this.priceWrapEl.classList.remove('visually-hidden');
      this.classList.remove('visually-hidden');
      this.bundleFormBuy.classList.remove('visually-hidden');
      this.bundleForm.querySelector('.form-loading').classList.add('hidden');

    } else {

      this.bundledProducts = this.dataset.productHandles.split(',');

      this.bundledProducts.forEach(productHandle => {

        var currentProductAvailable = '';
        var currentProductPrice = 0;
        var currentProductHtml = '';
        var html = ''

        fetch(`${window.shopUrl}/products/${productHandle}/?view=kit-item&currency=${window.Shopify.currency.active}`)
        .then(response => response.text())
        .then((responseText) => {
          html = new DOMParser().parseFromString(responseText, 'text/html')

          currentProductAvailable = html.querySelector('.wc-bundle-item-container .price').dataset.available;
          currentProductPrice =  parseInt(html.querySelector('.wc-bundle-item-container .price').dataset.bundleprice);
          currentProductHtml =  html.querySelector('.wc-bundle-item-container').outerHTML;

          this.bundleItemHtml = this.bundleItemHtml + currentProductHtml;
          this.bundleTotalCost = this.bundleTotalCost + currentProductPrice;
          this.bundleItemPos = this.bundleItemPos + 1;

          if(currentProductAvailable == 'false'){
            this.bundleAvailable = false;
          }

          this.append(html.querySelector('.wc-bundle-item-container'));
        })
        .then(() => {
          this.updateBundle()
        })
        .catch(error => {
          console.log(error)
          this.append(this.errorData);
          this.bundleForm.querySelector('.form-loading').classList.remove('hidden');
        })

      });
    }
    this.getAjacentProducts();
  }

  async getAjacentProducts() {
    const targetNode = document.querySelector('wc-kits');
    const handleObserver = (mutationList, observer) => {
      const kitProducts = document.querySelectorAll('[data-wc-selected-item-id]');
      if (kitProducts.length == this.bundledProducts.length) {
        observer.disconnect();
        const adjacentProductsContainers = document.querySelectorAll('[data-wc-adjacent-products-handle]');
        adjacentProductsContainers.forEach(async (container) => {
          const adjacentHandle = container.dataset.wcAdjacentProductsHandle;
          const searchAdjecentProductsUrl = `/search?view=wc-adjacent-products&q=${adjacentHandle}&options%5Bprefix%5D=none&type=product`;  
          try {
            const adjecentProductsHtml = await fetch(searchAdjecentProductsUrl);
            const adjecentProductsHtmlText = await adjecentProductsHtml.text();
            container.innerHTML = adjecentProductsHtmlText;
          } catch (error) {
            console.warn('Error finding product', error);
          }
        });
      }
    }

    const observer = new MutationObserver(handleObserver);
    observer.observe(targetNode, {attributes : true, childList : true, subtree : true});
  }

  async updateBundle() {
    
    if(this.bundleItemPos < this.bundleItemsTotal){
      return;
    }

    this.bundleForm.querySelector('.form-loading').classList.add('hidden');

    if(this.bundleAvailableGlobal == 'false'){
      this.bundleAvailable = false;
    }

    this.bundleDiscount = parseFloat((this.bundleTotalCost * this.bundlePercentage) / 100).toPrecision(12);
    this.bundleDiscountCost = parseFloat(this.bundleTotalCost - this.bundleDiscount).toPrecision(12);
    this.bundleTotalCost = parseFloat(this.bundleTotalCost / 100).toFixed(2);
    this.bundleDiscountCost = parseFloat(this.bundleDiscountCost / 100).toFixed(2);
    this.bundleSavingCost = parseFloat(this.bundleDiscount / 100).toFixed(2);

    this.bundleTotalCostDisplay = `${window.currencySymbol}`+ this.bundleTotalCost;
    this.bundleDiscountCostDisplay = `${window.currencySymbol}`+ this.bundleDiscountCost;
    this.bundleSavingCostDisplay = `${window.currencySymbol}`+ this.bundleSavingCost;

    this.priceRegularEl.forEach(priceReg => { priceReg.innerHTML = this.bundleTotalCostDisplay });
    this.priceSaleEl.forEach(priceSale => { priceSale.innerHTML = this.bundleDiscountCostDisplay });
    this.priceCostSaving.forEach(priceCost => { priceCost.querySelector('span').innerHTML = this.bundleSavingCostDisplay });


    if(parseInt(this.bundleTotalCost) > parseInt(this.bundleDiscountCost)){
      this.priceRegularWrapEl.forEach(priceReg => { priceReg.classList.add('hidden')});
      this.priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'block'});
    }else{
      this.priceRegularWrapEl.forEach(priceReg => { priceReg.classList.remove('hidden')});
      this.priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'none'});
      this.priceCostSaving.forEach(priceCost => { priceCost.classList.add('visually-hidden') });
    }

    this.priceWrapEl.classList.remove('visually-hidden');
    this.classList.remove('visually-hidden');

    this.bundleFormBuy.classList.remove('visually-hidden');
    this.bundleFormHiddenEl = this.bundleForm.querySelectorAll('input[type="hidden"]'); 

    if(this.bundleAvailable == false){
      this.bundleFormHiddenEl.forEach(hiddenEl => { hiddenEl.remove() });
      this.bundleFormBuy.setAttribute('disabled', 'disabled');
      this.bundleFormBuy.querySelector('.cta').classList.remove('available');
      this.bundleFormBuy.querySelector('.cta').classList.add('unavailable');
      this.style.opacity = '0.5';
      this.style.pointerEvents = 'none';
    }else{
      this.bundleFormBuy.removeAttribute('disabled');
      this.bundleFormBuy.querySelector('.cta').classList.add('available');
      this.bundleFormBuy.querySelector('.cta').classList.remove('unavailable')
    }

    sessionStorage.setItem(this.sessionStorageProdKey, JSON.stringify(this.bundleItemHtml));
    sessionStorage.setItem(this.sessionStorageBundlecostKey, JSON.stringify(this.bundleTotalCostDisplay));
    sessionStorage.setItem(this.sessionStorageBundleDiscountCostKey, JSON.stringify(this.bundleDiscountCostDisplay));
    sessionStorage.setItem(this.sessionStorageBundleSavingCostKey, JSON.stringify(this.bundleSavingCostDisplay));

  }
}

window.customElements.define('wc-kits', wcKits);

class wcKitsWrapper extends HTMLElement {
  constructor() {
    super()
    this.kit = this.querySelector('wc-kits');
    this.kitStepTemplate = document.querySelector('#wc-kit-step-template');
    this.stepContainer = this.querySelector('[data-wc-kit-steps]');
    this.kitSteps = [];
    this.kitProducts = [...this.querySelectorAll('[data-wc-selected-item-id]')];
    this.kitProductHandles = this.kit.dataset.productHandles.split(',');
    this.form = this.querySelector('form[action="/cart/add"]');
    this.priceCompareElement = this.querySelector('[wc-kit-compare]');
    this.priceSubtotalElement = this.querySelector('[wc-kit-subtotal]');
    this.priceDiscountElement = this.querySelector('[wc-kit-discount]');
    this.ctaButtons = this.querySelector('[data-wc-cta-buttons-select]');
    this.navStepNumber = this.querySelector('[wc-kit-step-number]');
    this.navStepProduct = this.querySelector('[wc-kit-step-product]');
    this.navSteps = [];
    this.currencySymbol = this.dataset.currencySymbol;
    this.discount = parseInt(this.dataset.discountPercent) / 100;
    this.comparePrice = 0;
    this.subTotal = 0;
    this.currentStep = 1;
    this.initProducts();
  }

  createNavSteps() {
    this.kitProducts.forEach((product, index) => {
      const kitStep = this.kitStepTemplate.content.firstElementChild.cloneNode(true);
      kitStep.querySelector('[wc-kit-step-title]').textContent = product.dataset.wcTitle;
      kitStep.querySelector('[wc-kit-step-number]').textContent = index + 1;
      if (index === 0) kitStep.classList.add('active');
      this.kitSteps.push(kitStep);
    });
    this.kitSteps.forEach(kitStep => {
      this.stepContainer.appendChild(kitStep);
    });
  }

  updatePricing() {
    const formatPrice = (price) => (price / 100).toFixed(2);
    const completedProducts = this.kitProducts.filter(product => product.dataset.stepComplete == 'true');
    const dataPrice = completedProducts.reduce((sum, product) => sum + parseInt(product.dataset.wcPrice), 0);
    
    this.comparePrice = formatPrice(dataPrice);
    this.subTotal = formatPrice(dataPrice - (dataPrice * this.discount));
    this.priceCompareElement.textContent = this.currencySymbol + this.comparePrice;
    this.priceSubtotalElement.textContent = this.currencySymbol + this.subTotal;

    completedProducts.forEach((product, index) => {
      const dataPrice = parseInt(product.dataset.wcPrice)
      const price = formatPrice(dataPrice - (dataPrice * this.discount));
      this.kitSteps[index].querySelector('[wc-kit-step-price]').textContent = this.currencySymbol + price;
    })
  }

  initProducts() {
    setTimeout(() => {
      const kitProducts = [...this.querySelectorAll('[data-wc-selected-item-id]')];
      kitProducts.forEach(product => {
        const index = this.kitProductHandles.indexOf(product.dataset.wcHandle);
        this.kitProducts[index] = product;
        product.dataset.wcPosition = index + 1;
      });
      this.createNavSteps();
      this.watchSteps();
      this.updatePricing();
      this.handleStepChange(1);
      this.setGalleryThumbs(this.dataset.productThumbnailSrc);
    }, 1500);
  }

  setGalleryThumbs(thumbnailSrc) {
    this.querySelectorAll('[wc-kit-product-thumbnail]').forEach(image => {
      image.src = thumbnailSrc;
    });
  }

  updateForm() {
    this.form = this.querySelector('form[action="/cart/add"]');
    this.kitProducts.forEach((product, index) => {
      const productId = product.dataset.wcSelectedItemId;
      const idInput = this.form.querySelector(`input[name="items[${index}][id]"]`);
      if (idInput) {
        idInput.value = productId;
      } else {
        this.form.innerHTML += `
          <input type="hidden" name="items[${index}][quantity]" value="1">
          <input type="hidden" name="items[${index}][id]" value="${productId}">
          <input type="hidden" name="items[${index}][properties][_bundle]"/>
        `;
      }
    });
  }

  updateStepImage(stepIndex) {
    const product = this.kitProducts[stepIndex - 1];
    const step = this.kitSteps[stepIndex - 1];
    const imgSrc = product.querySelector('.product__media img').src;
    const stepImage = step.querySelector('[wc-kit-step-img]');
    stepImage.src = imgSrc;
    stepImage.classList.remove('hidden');
  }

  handleStepChange(stepIndex) {
    const isFinalStep = this.kitSteps.length === stepIndex;
    const stepProduct = this.kitProducts[stepIndex - 1];
    const hasAdjacentProducts = stepProduct.dataset.wcHasAdjacentProducts === 'true';
    if (!hasAdjacentProducts ) stepProduct.dataset.stepComplete = true;
    const stepComplete = stepProduct.dataset.stepComplete === 'true';

    const needsSelection = hasAdjacentProducts && !stepComplete;
    this.ctaButtons.dataset.wcCtaButtonsSelect = needsSelection;

    if (stepIndex >= this.kitSteps.length || needsSelection) {
      this.stepButtonNext.setAttribute("disabled", true);
    } else {
      this.stepButtonNext.removeAttribute("disabled", true);
    }
    if (stepIndex <= 1) {
      this.stepButtonPrev.setAttribute("disabled", true);
    } else {
      this.stepButtonPrev.removeAttribute("disabled", true);
    }

    this.navStepNumber.textContent = stepIndex;
    this.navStepProduct.textContent = stepProduct.dataset.wcTitle;

    this.kit.dataset.activeItem = stepIndex;
    this.currentStep = stepIndex;
    this.kitSteps.forEach(step => {
      if (this.kitSteps.indexOf(step) === stepIndex - 1) {
        step.classList.add('active');
        step.scrollIntoView({behavior: "smooth"});
      } else {
        step.classList.remove('active');
      }
    });

    if (stepComplete) {
      this.kitProducts[stepIndex - 1].dataset.stepComplete = 'true';
      this.kitSteps[stepIndex - 1].dataset.wcKitStep = 'complete';
      this.updateStepImage(stepIndex);
      this.updatePricing();
      if (isFinalStep || this.allStepsComplete) {
        this.updateForm();
        this.allStepsComplete = true;
        this.dataset.allStepsComplete = true;
        const atcComparePrice = this.querySelector('[wc-kit-atc-compare]');
        const atcTotalPrice = this.querySelector('[wc-kit-atc-total]');
        atcComparePrice.textContent = this.currencySymbol + this.comparePrice;
        atcTotalPrice.textContent = this.currencySymbol + this.subTotal;
      }
    }
  }

  watchSteps() {
    this.stepButtonPrev = this.querySelector('[kit-step-buttons] [data-wc-step-button="prev"]');
    this.stepButtonNext = this.querySelector('[kit-step-buttons] [data-wc-step-button="next"]');
    this.stepButtons = this.querySelectorAll('[data-wc-step-button]');

    this.stepContainer.addEventListener('click', (event) => {
      const clickedStep = event.target.closest('[data-wc-kit-step]');
      if (clickedStep) {
        const stepIndex = this.kitSteps.indexOf(clickedStep) + 1;
        this.handleStepChange(stepIndex);
      }
    });

    this.stepButtons.forEach(button => {
      button.addEventListener('click', () => {
        const stepDirection = button.dataset.wcStepButton;
        this.handleStepChange(stepDirection === 'next' ? this.currentStep + 1 : this.currentStep - 1);
      });
    });

    const updateSwatchInfo = (product, adjacentProduct) => {
      const adjacentProductTitle = adjacentProduct.dataset.wcTitle;
      const adjacentProductDescription = adjacentProduct.dataset.wcDescription;
      product.querySelector('[wc-kit-variant-name]').textContent = adjacentProductTitle;
      product.querySelector('[wc-kit-variant-description]').textContent = adjacentProductDescription;
    }

    this.kitProducts.forEach(product => {
      product.addEventListener('click', event => {
        const adjacentProduct = event.target.closest('[data-wc-adjacent-product]');
        if (adjacentProduct) {
          product.dataset.stepComplete = true;
          product.dataset.wcPrice = adjacentProduct.dataset.wcSwatchPrice;
          const stepIndex = parseInt(product.dataset.wcPosition);
          updateSwatchInfo(product, adjacentProduct);
          this.handleStepChange(stepIndex);
        }
      })
    });
  }
}

window.customElements.define('wc-kits-wrapper', wcKitsWrapper);

class wcAdjacentProducts extends HTMLElement {
  constructor() {
    super()
    this.adjacentProducts = [...this.querySelectorAll('[data-wc-adjacent-product]')];
    this.galleries = {};
    this.productContainer = this.closest('.wc-bundle-item-container');
    this.kitWrapper = this.closest('.wc-kit-builder');
    this.galleryThumbnail = this.productContainer.querySelector('[wc-kit-gallery-thumbnail]');
    this.handleClick();
  }

  setInitialSwatch() {
    const initialProductId = this.productContainer.dataset.wcSelectedItemId;
    this.adjacentProducts.forEach(product => {
      if (product.dataset.wcSwatchId === initialProductId) product.classList.add('wc-selected');
    })
  }

  async fetchProductPageHTML(productHandle) {
    const response = await fetch(`/products/${productHandle}?view=kit-item`);
    const html = await response.text()
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html');
    console.log('doc loaded');
    return doc;
  }

  async loadAdjacentGallery(productHandle) {
    const doc = await this.fetchProductPageHTML(productHandle);
    this.galleries[productHandle] = doc.querySelector('media-gallery')

    const oldElement = this.productContainer.querySelector('media-gallery');
    if (!oldElement) return;
    try {
      const newElement = this.galleries[productHandle].cloneNode(true);
      oldElement.parentNode.replaceChild(newElement, oldElement);
      this.galleryThumbnail.src = newElement.querySelector('.product__media img').src;
    } catch (error) {
      console.log(newElement, error);
    }
    this.kitWrapper.updateStepImage(this.productContainer.dataset.wcPosition);
  }

  handleClick() {
    this.addEventListener('click', event => {
      if (event.target.closest('[data-wc-adjacent-product]')) {
        console.log('click')
        const clickedProduct = event.target.closest('[data-wc-adjacent-product]');
        const productHandle = clickedProduct.dataset.wcProductHandle
        const productId = clickedProduct.dataset.wcSwatchId;
        const productAvailble = clickedProduct.dataset.wcSwatchAvailble;
        this.adjacentProducts.forEach(adjacentProduct => {
          if (adjacentProduct === clickedProduct) {
            adjacentProduct.classList.add('wc-selected');
          } else {
            adjacentProduct.classList.remove('wc-selected');
          }
        });
        this.productContainer.dataset.wcSelectedItemId = productId;
        this.productContainer.dataset.wcSelectedItemAvailble = productAvailble;
        this.loadAdjacentGallery(productHandle);
      }
    });
  }
}
customElements.define('wc-adjecent-products', wcAdjacentProducts);
